import { Component, OnInit } from '@angular/core';
import { ProductsService } from 'src/app/_services/products.service';

@Component({
  selector: 'app-image-multi-v2',
  templateUrl: './image-multi-v2.component.html',
  styleUrls: ['./image-multi-v2.component.scss']
})
export class ImageMultiV2Component implements OnInit {
  fileToUpload: any;
  imageData = 'assets/150-26.jpg';

  constructor(public _productService: ProductsService) {}

  ngOnInit(): void {}

  handleFileInputMultiple(event: any) {
    const input = event.target as HTMLInputElement;
    const files = Array.from(input?.files || []);
    const existing = this._productService.thImages.length || 0;
    const remaining = 10 - existing;
    if (remaining <= 0) {
      alert('You can upload a maximum of 10 images.');
      if (input) {
        input.value = '';
      }
      return;
    }

    const invalidFiles = files.filter((file) => !this.isImageFile(file as File));
    const validFiles = files.filter((file) => this.isImageFile(file as File));

    if (invalidFiles.length) {
      alert('Invalid file type. Supported formats: PNG, JPG, JPEG, WEBP, GIF, BMP, SVG.');
    }

    const slice = validFiles.slice(0, remaining);
    if (!slice.length) {
      if (input) {
        input.value = '';
      }
      return;
    }

    slice.forEach((file: any) => {
      const fileName = (file as File).name;
      const reader = new FileReader();
      reader.onload = (ev: any) => {
        const base = ev.target.result;
        this._productService.thImages.push(base);
        this._productService.thImageNames.push(fileName);
        this._productService.hasGalleryChanged = true;
        if (this._productService.featureImageIndex === null) {
          this._productService.featureImageIndex = this._productService.thImages.length - 1;
          this._productService.featureImage = base;
        }
      };
      reader.readAsDataURL(file);
    });

    if (input) {
      input.value = '';
    }
  }

  onRemoveClick(event: any, i: any) {
    const removed = this._productService.thImages[i];
    this._productService.thImages.splice(i, 1);
    this._productService.thImageNames.splice(i, 1);
    this._productService.hasGalleryChanged = true;
    const currentIndex = this._productService.featureImageIndex;
    if (currentIndex !== null) {
      if (currentIndex === i) {
        this._productService.featureImageIndex =
          this._productService.thImages.length > 0 ? 0 : null;
      } else if (currentIndex > i) {
        this._productService.featureImageIndex = currentIndex - 1;
      }
    }
    this._productService.featureImage =
      this._productService.featureImageIndex !== null
        ? this._productService.thImages[this._productService.featureImageIndex]
        : null;
  }

  ok2AddThumbnails() {
    try {
      if (this._productService.thImages.length <= 9) return true;
    } catch {
      return true;
    }
    return false;
  }

  setFeatureImage(image: string, index: number) {
    if (this._productService.isViewOnly) return;
    this._productService.featureImageIndex = index;
    this._productService.featureImage = image;
    this._productService.hasGalleryChanged = true;
  }

  get remainingImages(): number {
    const total = this._productService.thImages?.length || 0;
    const remaining = 10 - total;
    return remaining > 0 ? remaining : 0;
  }

  private isImageFile(file: File): boolean {
    if (!file) return false;
    if (file.type) {
      return file.type.startsWith('image/');
    }

    const name = file.name || '';
    const ext = name.split('.').pop()?.toLowerCase() || '';
    return ['png', 'jpg', 'jpeg', 'webp', 'gif', 'bmp', 'svg'].includes(ext);
  }
}
